import { z } from "zod";

export const CompleteProfileViewModelSchema = z.object({
  userId: z.string(),
  name: z.string().min(1, "Name is required").max(100),
  password: z.string().min(8, "Password must be at least 8 characters").or(z.literal("")),
  isSubscribed: z.boolean(),
});

export type CompleteProfileViewModel = z.infer<typeof CompleteProfileViewModelSchema>;
